import { render } from "./ManageGroup.vue?vue&type=template&id=2e0d79d2&lang=pug"
import script from "./ManageGroup.vue?vue&type=script&lang=js"
export * from "./ManageGroup.vue?vue&type=script&lang=js"

import "./ManageGroup.vue?vue&type=style&index=0&id=2e0d79d2&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__